import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Key_getInstance4887rkxhu93r as Key_getInstance } from './CustomScalarAdapters.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { nullable1in0t8o94jx9t as nullable } from './Adapters.mjs';
import { MapJsonWriter4jz7ym6vbwk4 as MapJsonWriter } from './json/MapJsonWriter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Variables1mnjguxfc49u as Variables } from './Executable.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function falseVariables(_this__u8e3s4, customScalarAdapters) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = variables(_this__u8e3s4, customScalarAdapters, true).o47_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = LinkedHashMap().bc();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = tmp0.l3().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (equals(element.n3(), false)) {
      destination.x4(element.m3(), element.n3());
    }
  }
  return destination.v4();
}
function parseData(_this__u8e3s4, jsonReader, customScalarAdapters, falseVariables, deferredFragmentIds, errors) {
  customScalarAdapters = customScalarAdapters === VOID ? Key_getInstance().l46_1 : customScalarAdapters;
  falseVariables = falseVariables === VOID ? null : falseVariables;
  deferredFragmentIds = deferredFragmentIds === VOID ? null : deferredFragmentIds;
  errors = errors === VOID ? null : errors;
  var customScalarAdapters1 = customScalarAdapters.g44().t46(falseVariables).u46(deferredFragmentIds).v44(errors).c38();
  return nullable(_this__u8e3s4.p47()).p40(jsonReader, customScalarAdapters1);
}
function variables(_this__u8e3s4, customScalarAdapters, withDefaultValues) {
  // Inline function 'kotlin.apply' call
  var this_0 = new (MapJsonWriter())();
  this_0.q41();
  _this__u8e3s4.q47(this_0, customScalarAdapters, withDefaultValues);
  this_0.r41();
  var tmp = this_0.t41();
  var valueMap = (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
  return new (Variables())(valueMap);
}
//region block: exports
export {
  falseVariables as falseVariables32gd1w4dsf9iv,
  parseData as parseData1xjh6qzzvft3n,
};
//endregion

//# sourceMappingURL=Executables.mjs.map
